import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.NEXT_PUBLIC_CRYPTO_SECRET || '';

export const encryptData = (data) => {
  if (typeof data !== 'string') {
    data = JSON.stringify(data);
  }
  if (!SECRET_KEY) {
    return data;
  }

  try {
    return CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
  } catch (e) {
    console.error('Encryption failed:', e);
    return data; // Return the data as-is if encryption fails
  }
};

export const decryptData = (cipherText) => {
  if (!cipherText) {
    return '';
  }

  if (!SECRET_KEY) {
    return cipherText;
  }

  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

    return decryptedData;
  } catch (error) {
    console.error('Decryption failed:', error);
    return cipherText;
  }
};
